import PropTypes from "prop-types";
import { useHeaderState } from "./hooks";
import { setUtagLink } from "./utag-helpers";

const submissionsUrl = "/user/submissions";
// exclude submissions urls
const isNotExcluded = (href) => !href.includes(submissionsUrl);

const HeaderMenuLink = ({ href, name }) => {
  const { RouterLink, closeMenus } = useHeaderState();
  if (RouterLink && isNotExcluded(href)) {
    return (
      <RouterLink
        to={href}
        onClick={() => {
          closeMenus();
          setUtagLink("main navbar", "click", href);
        }}
        data-track-category="TopNav"
        data-track-action="click"
        data-track-label={name}
        className="nav-link"
      >
        {name}
      </RouterLink>
    );
  }
  return (
    <a
      href={href}
      className="nav-link"
      data-track-category="TopNav"
      data-track-action="click"
      data-track-label={name}
      onKeyDown={(e) => {
        if (e.key === " " || e.code === "Space") {
          window.location.href = window.location.origin + href;
          setUtagLink("main navbar", "keydown", href);
        }
      }}
      onClick={() => {
        setUtagLink("main navbar", "click", href);
      }}
    >
      {name}
    </a>
  );
};

HeaderMenuLink.propTypes = {
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default HeaderMenuLink;
